import React from "react";

export default function TabelaChamados({ dados, mes }) {
  return (
    <div
      className="overflow-y-auto border rounded-sm shadow-md shadow-black/40"
      style={{
        maxHeight: "400px", // altura aumentada
      }}
    >
      <table
        className="w-full text-sm text-left table-fixed"
        style={{ fontFamily: '"Source Sans Pro", sans-serif' }}
      >
        <thead
          className="sticky top-0 text-white"
          style={{ backgroundColor: "#4d4d4d" }}
        >
          <tr className="h-12">
            <th className="px-4 py-2 w-2/3">Cliente</th>
            {/* 🔹 só exibe coluna Mês se não for "todos" */}
            {mes !== "todos" && <th className="px-4 py-2 w-1/6">Mês</th>}
            <th className="px-4 py-2 w-1/12 text-center">Total</th>
          </tr>
        </thead>
        <tbody style={{ fontFamily: "Inter, sans-serif" }}>
          {dados.length > 0 ? (
            dados
              .sort((a, b) => b.total - a.total)
              .map((item, idx) => (
                <tr
                  key={idx}
                  className={`border-t ${
                    idx % 2 === 0 ? "bg-white" : "bg-gray-100"
                  } hover:bg-gray-200`}
                >
                  <td className="px-4 py-3">
                    {item.nome_cliente || item.cliente}
                  </td>
                  {/* 🔹 só exibe coluna Mês se não for "todos" */}
                  {mes !== "todos" && (
                    <td className="px-4 py-3">{item.mes}</td>
                  )}
                  <td className="px-4 py-3 text-center">{item.total}</td>
                </tr>
              ))
          ) : (
            <tr>
              <td
                colSpan={mes !== "todos" ? 3 : 2}
                className="text-center text-gray-500 py-4"
              >
                Nenhum dado disponível
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
